import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import Expanded from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_maximise.svg';
import Collapsed from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_minimise.svg';
import css from './expand-collapse-footer.scss';

export class ExpandCollapseFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: false
    };
  }

  toggleExpandCollapse() {
    this.setState({ isCollapsed: !this.state.isCollapsed });
  }

  render() {
    return (
      <div className={css.toggleContainer}>
        <div className={`${css.footer} ${this.state.isCollapsed ? css.collapsedContainer : css.expandedContainer}`}>
          {this.state.isCollapsed &&
            <span className={css.icon} role="button" tabIndex="-1" onClick={() => this.toggleExpandCollapse()}>
              <Isvg src={Expanded} cacheGetRequests />
            </span>}
          <div>
            {this.props.children}
          </div>
          {!this.state.isCollapsed &&
            <span
              className={`${css.icon} ${css.iconCollapsed}`}
              role="button"
              tabIndex="-1"
              onClick={() => this.toggleExpandCollapse()}>
              <Isvg src={Collapsed} cacheGetRequests />
            </span>}
        </div>
      </div>
    );
  }
}

ExpandCollapseFooter.propTypes = {
  children: PropTypes.object
};

export default ExpandCollapseFooter;
